import axios from "axios";

export const fetchHomeBannerChooserData = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_HOME_BANNER_CHOOSER_REQUEST" });

  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getHomeBannersData`,
      { headers }
    );

    dispatch({
      type: "FETCH_HOME_BANNER_CHOOSER_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_HOME_BANNER_CHOOSER_FAILURE",
      payload: error.message,
    });
  }
};
